import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { ApiKey } from '../types/api-key-types';

const UpdateApiKeysStore = createStore<UpdateApiKeysStoreState>(
  {
    selectedApiKey: null,
    errorMessage: null,
    isLoadingDeleteApiKey: false,
    isModalVisibleDeleteApiKey: false,
    isLoadingSetApiKeyStatus: false,
    isModalVisibleSetApiKeyStatus: false,
    isLoadingSetApiKeyExpiration: false,
    isModalVisibleSetApiKeyExpiration: false,
  },
  'Update API Key Store',
);

interface UpdateApiKeysStoreState {
  selectedApiKey: Nullable<ApiKey>;
  errorMessage: Nullable<string>;
  isLoadingDeleteApiKey: boolean;
  isModalVisibleDeleteApiKey: boolean;
  isLoadingSetApiKeyStatus: boolean;
  isModalVisibleSetApiKeyStatus: boolean;
  isLoadingSetApiKeyExpiration: boolean;
  isModalVisibleSetApiKeyExpiration: boolean;
}

export default UpdateApiKeysStore;
